import { render, staticRenderFns } from "./pg-redirect.vue?vue&type=template&id=722387fa&"
import script from "./pg-redirect.vue?vue&type=script&lang=js&"
export * from "./pg-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports